module.exports = __webpack_public_path__ + "img/icon-eye-hide-gray.24aa713a.svg";